module.exports = __webpack_public_path__ + "assets/936739b2e67e4d5cf480d0eff53d2e9f.png";